import React, { useState } from "react";
import logo from "../assets/logo_TMP.png";
import { Link, useNavigate } from "react-router-dom";

import {
  FaFacebook,
  FaInstagram,
  FaYoutube,
  FaTiktok,
  FaWhatsapp,
} from "react-icons/fa";

export const Navbar = () => {
  const navigate = useNavigate();

  const [menuOpen, setMenuOpen] = useState(false);

  const cerrarMenu = () => {
    setMenuOpen(false);
  };

  const irASeccion = (id) => {
    cerrarMenu();

    navigate("/");

    setTimeout(() => {
      const seccion = document.getElementById(id);

      if (seccion) {
        seccion.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      }
    }, 300);
  };

  return (
    <nav
      className="navbar navbar-expand-xl navbar-dark fixed-top"
      style={{
        background:
          "linear-gradient(135deg, #4f2876 50%, #370a33 100%, #0f5513 100%)",
      }}
    >
      {" "}
      <div className="container-lg">
        {/* LOGO */}{" "}
        <Link className="navbar-brand" to="/" onClick={cerrarMenu}>
          <img
            src={logo}
            alt="Teen Missions Perú"
            width="100"
            className="img-fluid"
          />
        </Link>
        {/* BOTÓN MÓVIL */}
        <button
          className="navbar-toggler"
          type="button"
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Abrir menú"
        >
          <span className="navbar-toggler-icon"></span>
        </button>
        <div
          className={`collapse navbar-collapse ${menuOpen ? "show" : ""}`}
          id="menu"
        >
          {/* MENÚ */}
          <ul className="navbar-nav mx-auto align-items-xl-center">
            <li className="nav-item">
              <Link
                className="nav-link fw-semibold"
                to="/conocenos"
                onClick={cerrarMenu}
              >
                Conócenos
              </Link>
            </li>
            {/* 
            <li className="nav-item">
              <button
                className="nav-link btn btn-link text-decoration-none fw-semibold"
                onClick={() => irASeccion("publicaciones")}
              >
                Noticias
              </button>
            </li>
*/}
            <li className="nav-item">
              <Link
                className="nav-link fw-semibold"
                to="/bootcamp"
                onClick={cerrarMenu}
              >
                Boot Camp
              </Link>
            </li>

            <li className="nav-item">
              <Link
                className="nav-link fw-semibold"
                to="/viajes"
                onClick={cerrarMenu}
              >
                Viajes
              </Link>
            </li>

            <li className="nav-item">
              <Link
                to="/sostenibilidad"
                className="nav-link fw-semibold"
                onClick={cerrarMenu}
              >
                Sostenibilidad
              </Link>
            </li>

            <li className="nav-item">
              <button
                className="nav-link btn btn-link text-decoration-none fw-semibold"
                onClick={() => irASeccion("contacto")}
              >
                Contacto
              </button>
            </li>
          </ul>

          {/* REDES */}
          <div className="social-icons d-flex align-items-center gap-3">
            <a
              href="https://www.facebook.com/TMIP1/"
              target="_blank"
              rel="noreferrer"
              className="social-link"
            >
              <FaFacebook />
            </a>

            <a
              href="https://www.instagram.com/teenmissionsperu/"
              target="_blank"
              rel="noreferrer"
              className="social-link"
            >
              <FaInstagram />
            </a>

            <a
              href="https://www.youtube.com/@teenmissionsperu"
              target="_blank"
              rel="noreferrer"
              className="social-link"
            >
              <FaYoutube />
            </a>

            <a
              href="https://www.tiktok.com/@teenmissionsperu"
              target="_blank"
              rel="noreferrer"
              className="social-link"
            >
              <FaTiktok />
            </a>

            <a
              href="https://wa.me/51987706440"
              target="_blank"
              rel="noreferrer"
              className="social-link"
            >
              <FaWhatsapp />
            </a>
          </div>
        </div>
      </div>
    </nav>
  );
};
